<template>
    <div>
        <form @submit.prevent="onSubmit" @keydown="form.errors.clear($event.target.name)" class="form">

            <fieldset>

                <div class="form__row form--required">
                    <label>Jméno</label>
                    <div class="form__controls">
                        <input type="text" name="jmeno" v-model="form.jmeno" placeholder="Jméno">
                        <div class="form-group__error" v-html="form.errors.get('jmeno')"></div>
                    </div>
                </div>

                <div class="form__row form--required">
                    <label>Příjmení</label>
                    <div class="form__controls">
                        <input type="text" name="prijmeni" v-model="form.prijmeni" placeholder="Příjmení">
                        <div class="form-group__error" v-html="form.errors.get('prijmeni')"></div>
                    </div>
                </div>

                <div class="form__row form--required">
                    <label>E-mail</label>
                    <div class="form__controls">
                        <input type="text" name="email" v-model="form.email" placeholder="E-mail">
                        <div class="form-group__error" v-html="form.errors.get('email')"></div>
                    </div>
                </div>

                <div class="form__row">
                    <div class="form__controls--no-label">
                        <button type="submit" class="btn btn-primary" :disabled="form.errors.any()">
                            Přihlásit
                            <i class="fa fa-fw fa-spinner fa-pulse" v-if="sending"></i>
                            <i class="fa fa-fw fa-chevron-right" v-else></i>
                        </button>
                    </div>
                </div>

            </fieldset>

        </form>
    </div>
</template>

<script>
    import Form from '../vn/Form.js';
    export default {

        props: [
            'endpoint'
        ],

        data() {
            return {
                form: new Form({
                    jmeno: _.get(window.App, ['auth', 'profile', 'jmeno']),
                    prijmeni: _.get(window.App, ['auth', 'profile', 'prijmeni']),
                    email: _.get(window.App, ['auth', 'email'])
                }),
                sending: false
            }
        },

        methods: {
            onSubmit() {
                this.sending = true;
                this.form.post(this.endpoint)
                    .then(response => {
                        this.sending = false;
                        swal({
                            title: 'Děkujeme',
                            // text: 'na Vaše případné dotazy odpovíme co nejdříve',
                            type: 'success',
                            timer: 5000
                        })
                        .then(result => location.reload());
                    })
                    .catch(errors => {
                        this.sending = false;
                        // other than validation error
                        if (errors.status !== 422) {
                            console.log(errors);
                            alert('Chyba při odesílání formuláře');
                        }
                    });
            }
        }
    }
</script>

<style>
    .form-group__error {
        padding-left: .5em;
        font-size: .9em;
        color: #b21d31;
    }
</style>
